<script>
import { canUserAccess, hasRole, toFixed,getFieldsForExport ,is_admin_employee} from '../../../utils'
import moment from "moment";

export default {
  methods: {
    $is_admin_employee(){
        return is_admin_employee()
    },
    $can(permissionName, moduleSlug) {
      return canUserAccess(permissionName, moduleSlug)
    },
    $hasRole(role) {
      return hasRole(role)
    },
    $toFixed(number, digits) {
      return toFixed(number, digits)
    },
    $getFieldsForExport(fields){
      return getFieldsForExport(fields)
    },
    $toTimezone(date,tz="UTC",from_format = 'D/M/Y H:m',to_format ='Y-M-D H:mm'){
        try{
            if(date){
                if(from_format)
                    return this.moment(date,from_format).tz('UTC').format(to_format)
                else return this.moment(date).tz('UTC').format(to_format)
            }
        }
        catch (e){
            return date
        }
    },
    $fromTimezone(date,tz= "UTC",from_format = "YYYY/MM/DD h:mm A",to_format = 'DD/MM/YYYY h:mm A'){
        try{
            if(date){
                if(from_format)
                    return this.moment.tz(date,from_format,"UTC").tz(this.moment.tz.guess()).format(to_format)
                else return this.moment.tz(date).tz(this.moment.tz.guess()).format(to_format)
            }
        }
        catch (e){
            return date
        }
    },
    $getDateRanges(){
        let today = new Date()
        today.setHours(0, 0, 0, 0)

        let yesterday = new Date()
        yesterday.setDate(today.getDate() - 1)
        yesterday.setHours(0, 0, 0, 0);
        return {
            'Today': [this.moment().startOf('day').toDate(), this.moment().endOf('day').toDate()],
            'Yesterday': [this.moment().subtract(1,'days').startOf('day').toDate(), this.moment().subtract(1,'days').endOf('day').toDate()],
            'This week':[this.moment().startOf('week').toDate(),this.moment().endOf('week').toDate(),],
            'Last week':[this.moment().startOf('week').subtract(1,'week').toDate(),this.moment().endOf('week').subtract(1,'week').toDate(),],
            'This month': [this.moment().startOf('month').toDate(),this.moment().endOf('month').toDate()],
            'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
            'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
            'Last year': [this.moment().subtract(1,'years').startOf('year').toDate(),this.moment().subtract(1,'years').endOf('year').toDate()],
            'Last year to now': [this.moment().subtract(1,'years').startOf('year').toDate(),this.moment().endOf('day').toDate()],
            
        }

    }
  },
}
</script>
